import 'react-loading-skeleton/dist/skeleton.css'
import './app.css'

// Legacy color values for icon colors only
// TODO: Migrate to CSS variables
export const colors = {
  success: '#11BB8D',
  accentInverted: '#2150A9',
  primary: '#015FCB',
  danger: '#FF0000',
  rebalancing: '#FF8A00',
  secondaryText: '#666666',
}
